import { Instagram, Linkedin } from 'lucide-react';
import Arrow from './ActionArrow';

const profiles = [
  { label: 'Instagram', href: 'https://www.instagram.com/catalyst_seven_/', Icon: Instagram },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/catalyst7-creative-ai-studio/', Icon: Linkedin },
];

export default function SocialLinks({ compact = false }) {
  return <nav className={`social-links${compact ? ' social-links-compact' : ''}`} aria-label="Catalyst 7 social profiles">
    {profiles.map(({ label, href, Icon }) => <a key={label} className="text-link social-link" href={href} target="_blank" rel="noopener noreferrer" aria-label={`${label} — Catalyst 7 (opens in a new tab)`}>
      <Icon size={16} strokeWidth={1.6} aria-hidden="true" /><span>{label}</span>{!compact && <Arrow />}
    </a>)}
  </nav>;
}
